import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7392688c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "view",
  "data-view": ""
}
const _hoisted_2 = {
  key: 1,
  class: "bag"
}
const _hoisted_3 = { class: "bag__nav" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" decola shop ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "/", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "meu carrinho", -1))
const _hoisted_7 = { class: "bag__header" }
const _hoisted_8 = { class: "bag__title" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "carrinho de compras", -1))
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "bag__amount" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Total: ")
const _hoisted_13 = {
  key: 0,
  class: "bag__validation"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "line" }, null, -1))
const _hoisted_15 = { class: "bag__container" }
const _hoisted_16 = { class: "img-limiter" }
const _hoisted_17 = { class: "bag__information" }
const _hoisted_18 = ["data-description"]
const _hoisted_19 = ["data-see-more", "onClick"]
const _hoisted_20 = { class: "bag__total" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Preço unit: ")
const _hoisted_22 = { class: "decoins" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Preço total: ")
const _hoisted_24 = { class: "decoins" }
const _hoisted_25 = { class: "bag__buttons" }
const _hoisted_26 = ["onClick", "disabled"]
const _hoisted_27 = ["onClick", "disabled"]
const _hoisted_28 = {
  key: 0,
  class: "bag__validation"
}
const _hoisted_29 = {
  key: 1,
  class: "bag__validation"
}
const _hoisted_30 = {
  key: 2,
  class: "bag__validation"
}
const _hoisted_31 = {
  key: 3,
  class: "bag__validation"
}
const _hoisted_32 = {
  key: 0,
  class: "bag__validation"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  key: 2,
  class: "bag__empty"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bag__title-span" }, "Seu carrinho está vazio no momento.", -1))
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" voltar à loja ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_receipt_modal = _resolveComponent("receipt-modal")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_HoverGallery = _resolveComponent("HoverGallery")!
  const _component_TUIViewer = _resolveComponent("TUIViewer")!
  const _component_modal_alert = _resolveComponent("modal-alert")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isModalOpened)
      ? (_openBlock(), _createBlock(_component_receipt_modal, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.bagProducts?.length)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createElementVNode("nav", _hoisted_3, [
            _createVNode(_component_router_link, {
              to: { name: 'shop' },
              class: "bag__link"
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _hoisted_5,
            _hoisted_6
          ]),
          _createElementVNode("header", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("button", {
                class: _normalizeClass([
              'bag__button__finish',
              _ctx.shouldButtonDisabled ? 'blocked' : '',
            ]),
                disabled: _ctx.shouldButtonDisabled,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.finishOrder && _ctx.finishOrder(...args)))
              }, " finalizar compra ", 10, _hoisted_10)
            ]),
            _createElementVNode("p", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("span", null, _toDisplayString(_ctx.formatDecoins(_ctx.amountTotal)), 1)
            ]),
            (_ctx.userDoNotHaveDecoinsEnough())
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Valor total ultrapassou seus decoins. Não é possível finalizar a compra!"))
              : _createCommentVNode("", true),
            _hoisted_14
          ]),
          _createElementVNode("ul", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bagProducts, (product, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: "bag__product"
              }, [
                _createVNode(_component_router_link, {
                  class: _normalizeClass([
              'bag__detail',
              _ctx.notStock(product) ||
              _ctx.checkProductDecoins(product) ||
              _ctx.checkProductIsActive(product)
                ? 'disabled'
                : '',
            ]),
                  to: { name: 'product_detail', params: { productID: product.id } }
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_HoverGallery, {
                        gallery: product.imagesUrl
                      }, null, 8, ["gallery"])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("h2", null, _toDisplayString(product.name), 1),
                      _createElementVNode("div", null, [
                        _createElementVNode("p", { "data-description": index }, [
                          _createVNode(_component_TUIViewer, {
                            "model-value": product.description
                          }, null, 8, ["model-value"])
                        ], 8, _hoisted_18),
                        _createElementVNode("button", {
                          "data-see-more": index,
                          class: "products__see-more",
                          onClick: _withModifiers(($event: any) => (_ctx.seeMoreDescription(index)), ["stop","prevent"])
                        }, " ver mais ", 8, _hoisted_19)
                      ]),
                      _createElementVNode("span", _hoisted_20, [
                        _createElementVNode("span", null, [
                          _hoisted_21,
                          _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.formatDecoins(product.decoins)), 1)
                        ]),
                        _createElementVNode("span", null, [
                          _hoisted_23,
                          _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.amount(product.decoins, product.quantity)), 1)
                        ])
                      ]),
                      _createElementVNode("span", {
                        class: _normalizeClass([
                  _ctx.notStock(product)
                    ? 'bag__span-not-stock'
                    : 'bag__span-in-stock',
                ])
                      }, _toDisplayString(_ctx.notStock(product) ? "Sem estoque" : "Em estoque"), 3)
                    ])
                  ]),
                  _: 2
                }, 1032, ["class", "to"]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", {
                    class: _normalizeClass([
                'bag__content',
                _ctx.checkProductIsActive(product) ? 'disabled' : '',
              ])
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass([
                  'bag__add-button__remove-button',
                  _ctx.notStock(product) ? 'disabled' : '',
                ])
                    }, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.decreaseProduct(product)),
                        disabled: 
                    _ctx.disabled(product.quantity) || _ctx.checkProductIsActive(product)
                  
                      }, " - ", 8, _hoisted_26),
                      _createElementVNode("span", null, _toDisplayString(product.quantity) + " / " + _toDisplayString(product.stock), 1),
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.increaseProduct(product)),
                        disabled: 
                    _ctx.isProductOutOfStock(product) ||
                      _ctx.checkEnough(product) ||
                      _ctx.checkQuantity(product) ||
                      _ctx.checkProductIsActive(product)
                  
                      }, " + ", 8, _hoisted_27)
                    ], 2),
                    (_ctx.exceededStock(product))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_28, "estoque máximo atingido!"))
                      : _createCommentVNode("", true),
                    (_ctx.notStock(product))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_29, "produto sem estoque, remova-o do carrinho!"))
                      : _createCommentVNode("", true),
                    (
                  _ctx.checkProductDecoins(product) &&
                    !_ctx.checkQuantity(product) &&
                    !_ctx.checkProductIsActive(product)
                )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_30, " valor do produto modificado, você não possui decoins para finalizar a compra. Remova este produto! "))
                      : _createCommentVNode("", true),
                    (_ctx.checkQuantity(product))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_31, " preço total do produto ultrapassou seu saldo, diminua a quantidade! "))
                      : _createCommentVNode("", true)
                  ], 2),
                  (product.isActive === false)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_32, " Produto indisponível! "))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.removeFromBag(product)),
                    class: "bag__remove-button"
                  }, " Remover ", 8, _hoisted_33)
                ])
              ]))
            }), 128))
          ]),
          (_ctx.isModalAlertOpened)
            ? (_openBlock(), _createBlock(_component_modal_alert, { key: 0 }))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _hoisted_35,
          _createVNode(_component_router_link, {
            to: { name: 'shop' },
            class: "bag__button-span"
          }, {
            default: _withCtx(() => [
              _hoisted_36
            ]),
            _: 1
          })
        ]))
  ]))
}